import { useState } from 'react';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { Frame } from '#src/contexts/wallet/Frame/index.tsx';
import { useWalletContext } from '#src/contexts/wallet/index.ts';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';

export const FrameWhenNeeded = () => {
  const { currentUser } = useCurrentUserContext();
  const { walletNode } = useWalletContext();
  const { isMobileApp } = useIsMobileApp();
  const [needed, setNeeded] = useState(false);

  // The native apps listen for the frame's `loaded` message.
  if (!needed && (isMobileApp || currentUser || walletNode)) {
    setNeeded(true);
  }

  return needed ? <Frame /> : null;
};
